import React, {Component} from "react"
import PropTypes from "prop-types"
import {FormControl} from "react-bootstrap"

import id from "@irati/utils/id"
import ValidationInput, {ValidationProps} from "@irati/utils/validation/Input"

import {SpacedErrorText} from "./styled/Hidden"

type Value = string | number | object

interface Props extends ValidationProps {
  id?: string
  error?: string
  value?: Value
  name: string
}

interface State {
  value?: Value
  errorMsg: string | null
}

export class Hidden extends Component<Props, State> {
  validation: ValidationInput

  static contextTypes = {
    currentScreen: PropTypes.string
  }

  static defaultProps: Pick<Props, "value"> = {
    value: ""
  }

  constructor(props: Props) {
    super(props)
    this.state = {
      errorMsg: null,
      value: props.value
    }

    this.validation = new ValidationInput(this)
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    this.validation.update(prevProps, prevState)
  }

  componentWillUnmount() {
    this.validation.destroy()
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    this.setState({value: nextProps.value})
  }

  render() {
    const {name, error} = this.props
    const {errorMsg, value} = this.state

    const idNamespace = id("Hidden", this.props)
    const idInput = id(name, idNamespace) || name
    const thisError = errorMsg || error

    return (
      <span>
        <FormControl id={idInput} type="hidden" value={value} />
        {thisError && (
          <SpacedErrorText id={id("copy-error", idNamespace)} small>
            {thisError}
          </SpacedErrorText>
        )}
      </span>
    )
  }
}

export default Hidden
